module.exports = __webpack_public_path__ + "img/1242.d209f134.gif";